export const BLOG_CATEGORY = 'blogCategory';
export const EVENT_CATEGORY = 'eventCategory';

export const BLOG_TAGS = 'blogTags';
